import material_model from '@/shared/models/material_model';
import unidad_medida_model from '@/shared/models/unidad_medida_model';
import ubicacion_model from '@/shared/models/ubicacion_model';

export const inventory_movement_detail_model = {
  Codigo: null,
  CodigoItemSecuencia: null,
  CodigoItem: null,
  CodigoAdicional: null,
  NumeroSerie: null,
  CodigoStockSeries: null,
  Descripcion: null,
  Cantidad1: 0,
  CodigoUnidadMedida1: null,
  Cantidad2: null,
  CodigoUnidadMedida2: null,
  Cantidad3: null,
  CodigoUnidadMedida3: null,
  CodigoUbicacion: null,
  CodigoUbicacionDestino: null,
  FactorConversion: null,
  FactorConversion23: null,
  OT: null,
  Lote: null,
  OC: null,
  Observaciones: null,
  Material: { ...material_model },
  UnidadMedida1: { ...unidad_medida_model },
  UnidadMedida2: { ...unidad_medida_model },
  UnidadMedida3: { ...unidad_medida_model },
  Ubicacion: { ...ubicacion_model },
  UbicacionDestino: { ...ubicacion_model },
};
